import { Suspense } from "react";
import App from "../App/App";
import { LicenseInfo } from "@mui/x-license";
import GlobalProviders from "components/App/AppInitialiser/config/GlobalProviders";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_LICENSE_KEY);

function Root() {
  return (
    <Suspense>
      <GlobalProviders>
        <App />
      </GlobalProviders>
    </Suspense>
  );
}

export default Root;
